var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-root",attrs:{"data-testid":"month-chart-root"}},[(_vm.loading)?_c('div',{staticClass:"blocking-loader"},[_c('AlLoading')],1):_vm._e(),_c('highcharts',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }